import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {CatalogueResourceItem, ICatalogueResourceItem} from 'app/blocks/model/resource-item.model';
import {CatalogueResourceItemService} from 'app/blocks/service/api/resource-item.service';

@Injectable({
    providedIn: 'root'
})
export class CatalogueResourceItemResource extends AbstractEntityResource<ICatalogueResourceItem> {
    constructor(resourceItemService: CatalogueResourceItemService, router: Router) {
        super(
            Resource.RESOURCE_ITEMS,
            resourceItemService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.RESOURCE_ITEMS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.RESOURCE_ITEMS),
            (entity?) => new CatalogueResourceItem(entity),
            (entity) => entity.id
        );
    }
}
